import React, {useState, useEffect} from 'react';
import {Spinner} from '../../../ui-toolkit/animation/loading/Spinner';
import {useTranslation, withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {Page} from '../../../ui-toolkit/page/Page';
import {Main} from '../../../ui-toolkit/page/Main';
import _ from 'lodash';

const DelayedLoadingState = ({children}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timerId = _.delay(() => setShow(true), 2000);

        return () => {
            clearTimeout(timerId);
        };
    }, []);

    if (!show) return null;

    return children;
};

const LoadingState = () => {
    const {t} = useTranslation();
    return (
        <Page>
            <Main>
                <DelayedLoadingState>
                    <LoadingStateWrapper>
                        <Spinner />
                        <p>{t('generalShared.loading')}</p>
                    </LoadingStateWrapper>
                </DelayedLoadingState>
            </Main>
        </Page>
    );
};

export const LoadingStateWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: calc((100% + var(--nav-sidebar-width)) / 2);
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 40px;
`;

export default withTranslation()(LoadingState);
